var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "19px",
    viewBox: "0 0 16 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rough-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_bell",
    transform: "translate(-4.000000, -3.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7696068,17.5196068 C18.3280219,17.9611916 18.0304911,18 17,18 L7,18 C5.9695089,18 5.67197807,17.9611916 5.23039322,17.5196068 C4.66998259,16.9591961 4.69629182,16.2488469 5.03847605,15.2252789 L6,11.8599451 L6,10 C6,5.61805728 8.29081767,3 12.0000536,3 C15.7092705,3 18,5.61803672 18,10 L18,11.8599451 L18.9557227,15.2049745 C19.3040322,16.2582884 19.3262905,16.9629231 18.7696068,17.5196068 Z M17.1093266,15.9998363 C17.0926076,15.9434499 17.0733165,15.8822271 17.0513167,15.8162278 L17.0384761,15.7747211 L16,12.1400549 L16,10 C16,6.6676075 14.540877,5 12.0000536,5 C9.45919574,5 8,6.66763949 8,10 L8,12.1400549 L7.96152395,12.2747211 L6.9486833,15.8162278 C6.92668352,15.8822271 6.90739237,15.9434499 6.89067338,15.9998363 C6.92422186,16 6.96054966,16 7,16 L17,16 C17.0394503,16 17.0757781,16 17.1093266,15.9998363 Z M8.5,19 L10.5,19 C10.5,19.754319 10.8439534,20 12,20 C13.1560466,20 13.5,19.754319 13.5,19 L15.5,19 C15.5,21.0313953 14.1439534,22 12,22 C9.8560466,22 8.5,21.0313953 8.5,19 Z",
    id: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.71e794789292355366e2225c434835fe.svg";
export { ForwardRef as ReactComponent };